<template>
  <div class="hero">
    <div class="container h-100">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col-md-5">
          <div class="hero-content">
            <h1 class="hero-title">Community trash management made simple</h1>
            <p>Easily add, view and manage community trash requests for your town or municipality.</p>
            <div class="hero-btn mt-4">
              <a
                class="btn btn-outline-primary custom-btn mr-4"
                href="#"
                role="button"
                data-toggle="modal"
                data-target="#login"
              >Login</a>
              <a
                class="btn btn-primary btn-primary custom-btn mr-4 disabled"
                href="#"
                role="button"
                data-toggle="modal"
                data-target="#adminlogin"
              >Request Demo</a>
              <!-- <button class="btn custom-btn btn-outline-secondary">Products</button> -->
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div class="graphic">
            <img src="/img/svg/graphic.svg" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hero {
  padding-top: 7rem;
  width: 100%;
  height: 500px;
  text-align: left;
}
</style>